import { en } from 'vuetify/lib/locale'

import loginPage from './views/LoginPage-en'
import paymentGate from './views/PaymentGate-en'
import paymentResult from './views/PaymentResult-en'
import paymentList from './views/PaymentList-en'
import footer from './components/Footer-en'
import appBar from './components/AppBar-en'

export default {
    ...en,
    loginPage,
    paymentGate,
    paymentResult,
    footer,
    paymentList,
    appBar
}
